import React, { createContext, useState, useContext } from 'react'
import { useLocalStorage } from '../../hooks'
import { isANumber } from '../../utils'
import { OTPLogin, silentLoginService } from '../../services'
import { validateOtpRegistration } from '../../services/validateOtpRegistration'

const AuthContext = createContext(null)

const initialLoginStatus = {
    isUserLoggedIn: false,
    userId: null,
    accessToken: null,
    refreshToken: null,
    phoneNumber: null,
}

export const AuthProvider = ({ children }) => {
    const [phoneNumber, setPhoneNumber] = useState('')

    const [storedLoginStatus, setStoredLoginStatus] = useLocalStorage('projectHeroLogin', initialLoginStatus)

    const [user, setUser] = useState(storedLoginStatus)

    const { isUserLoggedIn, userId } = user

    const loginUser = (user) => {
        const { accessToken, refreshToken, ...customerData } = user.data
        const loginState = {
            isUserLoggedIn: true,
            accessToken,
            refreshToken,
            userId: customerData._id,
            phoneNumber: customerData.phoneNumber,
        }

        setUser((prevUser) => ({
            ...prevUser,
            ...loginState,
        }))
        setStoredLoginStatus(loginState)
    }

    const silentlyLoginUser = (user) => {
        const { accessToken, ...customerData } = user.data
        const loginState = {
            isUserLoggedIn: true,
            accessToken,
            refreshToken: storedLoginStatus?.refreshToken,
            userId: customerData._id,
            phoneNumber: customerData.phoneNumber,
        }

        if (user.data?.refreshToken) {
            loginState.refreshToken = user.data?.refreshToken
        }

        setUser((prevUser) => ({
            ...prevUser,
            ...loginState,
        }))
        setStoredLoginStatus(loginState)
    }

    // setupAuthHeaders(user.accessToken);

    function logout() {
        localStorage.removeItem('projectHeroLogin')
        setUser(initialLoginStatus)
    }

    const loginByOtp = async (phoneNumber, otp) => {
        try {
            const res = await OTPLogin(phoneNumber, otp)
            if (res?.data?.success) {
                loginUser(res.data)
            }
            return res
        } catch (error) {
            console.log(error.message)
            return {
                data: {
                    error: 'Something went wrong',
                },
            }
        }
    }

    const silentLogin = async (phoneNumber, accessToken) => {
        try {
            const res = await silentLoginService(phoneNumber, accessToken)
            if (res?.data?.success) {
                silentlyLoginUser(res.data)
            }
            return res
        } catch (error) {
            console.log(error.message)
            return {
                data: {
                    error: 'Something went wrong',
                },
            }
        }
    }

    // const loginByOtp2 = async ({ phoneNumber, otp }) => {
    //   try {
    //     const res = await validateOtp(phoneNumber, otp);
    //     if (res?.data?.success) {
    //       loginUser(res.data);
    //     }
    //     return res;
    //   } catch (error) {
    //     console.log(error.message);
    //     return {
    //       data: {
    //         error: "Something went wrong",
    //       },
    //     };
    //   }
    // };

    const registerByOtp = async (phoneNumber, otp) => {
        try {
            console.log('COMING TO REGISTRATION BY OTP')
            const res = await validateOtpRegistration(phoneNumber, otp)
            if (res?.data?.success) {
                // loginUser(res.data);
                await silentLogin(phoneNumber, res?.data?.data?.accessToken)
            }
            return res
        } catch (error) {
            console.log(error.message)
            return {
                data: {
                    error: 'Something went wrong',
                },
            }
        }
    }

    const handlePhoneNumber = (e) => {
        const value = e.target.value
        if (isANumber(value)) {
            setPhoneNumber(value)
        }
    }

    return (
        <AuthContext.Provider
            value={{
                phoneNumber,
                handlePhoneNumber,
                loginByOtp,
                registerByOtp,
                logout,
                isUserLoggedIn,
                userId,
                user,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => {
    return useContext(AuthContext)
}
